export enum LenderIdentificationStatus {
  NOT_VERIFIED = 'NOT_VERIFIED',
  INFO_REQUESTED = 'INFO_REQUESTED',
  VERIFIED = 'VERIFIED',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
}
